import { z } from 'zod';

export const TelegramLoginWidgetInput = z.object({
  id: z.number().int().positive(),
  first_name: z.string().min(1),
  last_name: z.string().optional(),
  username: z.string().optional(),
  photo_url: z.url().optional(),
  auth_date: z.number().int().positive(),
  hash: z.string().regex(/^[a-f0-9]{64}$/, 'hex64 expected'),
});
export type TelegramLoginWidgetInput = z.infer<typeof TelegramLoginWidgetInput>;
